import { useQuery } from '@tanstack/react-query';
import apiClient from "./apiClient";

export interface Magasin {
  id: string;
  name: string;
  addresse: string;
  ville: string;
  codePostal: string;
  telephone: string;
  courriel: string;
}

export const getMagasins = async (): Promise<Magasin[] | null> => {
  try {
    const response = await apiClient.get<Magasin[]>("/magasin");
    return response.data;
  } catch (error) {
    // console.error("Failed to fetch magasin list:", error);
    return null;
  }
};

export const useMagasins = () => {
  return useQuery({
    queryKey: ['magasins'],
    queryFn: getMagasins,
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 30, // 30 minutes
  });
};
